import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { useFormats } from "@ryde/shared";

import { INVESTIGATION_HISTORY } from "../investigation.constants";
import { HistoryLifecycleStyled } from "../investigation.history.styled";
import type { IInvestigationLifecycleStep } from "../investigation.models";

interface IInvestigationHistoryLifecycleProps {
  steps: IInvestigationLifecycleStep[];
}

/** Created → Sent → Started → Arrived → Closed, with a step that was skipped called out in words. */
export const InvestigationHistoryLifecycle: FC<
  IInvestigationHistoryLifecycleProps
> = ({ steps }) => {
  const { t } = useTranslation();
  const { formatDateTimeNormalized } = useFormats();
  const key = `${INVESTIGATION_HISTORY.i18nKey}.lifecycle`;

  return (
    <HistoryLifecycleStyled aria-label={t(`${key}.title`)}>
      {steps.map(step => (
        <li
          key={step.key}
          className={`lifecycle-step lifecycle-step--${step.state}`}
        >
          <span className="lifecycle-label">{t(`${key}.${step.key}`)}</span>
          <span className="lifecycle-time">
            {step.tMs !== undefined &&
              formatDateTimeNormalized(
                new Date(step.tMs).toISOString() as TDateISO,
              )}
            {step.tMs === undefined &&
              step.state !== "done" &&
              t(`${key}.${step.state}`)}
          </span>
        </li>
      ))}
    </HistoryLifecycleStyled>
  );
};
